import { C } from '../styles/tokens';


// `tool` is the canonical analytics key for the tile (see Dashboard - Tool Clicked).
const TOOLS = [
  { label: 'Voice Designer',  sub: 'Prompt to voice',             art: 'spark',   accent: '#7C3AED', grad: 'linear-gradient(135deg,#F5F3FF 0%,#EDE9FE 100%)', nav: 'voice',           tool: 'voice_designer' },
  { label: 'Voice Isolator',  sub: 'Isolate voice from noise',    art: 'wavecut', accent: '#16A34A', grad: 'linear-gradient(135deg,#F0FDF4 0%,#DCFCE7 100%)', nav: 'voice-isolator',  tool: 'voice_isolator' },
  { label: 'Voice Changer',   sub: 'Change voice style',          art: 'morph',   accent: '#0891B2', grad: 'linear-gradient(135deg,#ECFEFF 0%,#CFFAFE 100%)', nav: 'voice-changer',   tool: 'voice_changer' },
  { label: 'Sound Generator', sub: 'AI SFX generator',            art: 'burst',   accent: '#D97706', grad: 'linear-gradient(135deg,#FFFBEB 0%,#FEF3C7 100%)', nav: 'sound-effects',   tool: 'sound_generator' },
  { label: 'Voice Library',   sub: '900+ voices, 100+ languages', art: 'faces',   accent: '#2563EB', grad: 'linear-gradient(135deg,#EFF6FF 0%,#DBEAFE 100%)', nav: 'voice',           tool: 'voice_library' },
];

function MiniArt({ tag, accent }) {
  const common = { position: 'absolute', right: -6, top: '50%', transform: 'translateY(-50%) scale(0.8)', opacity: .85, pointerEvents: 'none' };
  if (tag === 'spark') return (
    <svg style={common} width="64" height="64" viewBox="0 0 64 64" fill="none">
      <path d="M32 8l4.4 13.6L50 26l-13.6 4.4L32 44l-4.4-13.6L14 26l13.6-4.4z" fill={accent} opacity=".28" />
      <path d="M48 40l2.2 6.8L57 49l-6.8 2.2L48 58l-2.2-6.8L39 49l6.8-2.2z" fill={accent} opacity=".45" />
    </svg>
  );
  if (tag === 'wavecut') return (
    <svg style={common} width="70" height="60" viewBox="0 0 70 60" fill="none">
      {Array.from({ length: 9 }, (_, i) => {
        const h = [10, 20, 32, 44, 36, 24, 16, 26, 12][i];
        return <rect key={i} x={i * 7 + 3} y={(60 - h) / 2} width="3.5" height={h} rx="1.75" fill={accent} opacity={i < 4 ? .5 : .18} />;
      })}
      <line x1="34" y1="6" x2="34" y2="54" stroke={accent} strokeWidth="2" strokeDasharray="3 4" opacity=".55" />
    </svg>
  );
  if (tag === 'morph') return (
    <svg style={common} width="68" height="60" viewBox="0 0 68 60" fill="none">
      <circle cx="22" cy="30" r="14" stroke={accent} strokeWidth="2.5" opacity=".3" fill="none" />
      <circle cx="44" cy="30" r="14" stroke={accent} strokeWidth="2.5" opacity=".55" fill="none" />
      <path d="M30 24c3 2 3 10 0 12M36 24c-3 2-3 10 0 12" stroke={accent} strokeWidth="2" strokeLinecap="round" opacity=".6" />
    </svg>
  );
  if (tag === 'burst') return (
    <svg style={common} width="64" height="60" viewBox="0 0 64 60" fill="none">
      <circle cx="32" cy="30" r="5" fill={accent} opacity=".6" />
      {Array.from({ length: 8 }, (_, i) => {
        const a = i * Math.PI / 4;
        return <line key={i} x1={32 + Math.cos(a) * 10} y1={30 + Math.sin(a) * 10} x2={32 + Math.cos(a) * (16 + (i % 2) * 6)} y2={30 + Math.sin(a) * (16 + (i % 2) * 6)} stroke={accent} strokeWidth="2.5" strokeLinecap="round" opacity={i % 2 ? .3 : .5} />;
      })}
    </svg>
  );
  if (tag === 'faces') return (
    <svg style={common} width="72" height="60" viewBox="0 0 72 60" fill="none">
      <circle cx="24" cy="24" r="10" fill={accent} opacity=".25" />
      <circle cx="42" cy="30" r="10" fill={accent} opacity=".45" />
      <circle cx="58" cy="22" r="8" fill={accent} opacity=".3" />
      <path d="M14 48c2-6 8-9 10-9s8 3 10 9M32 52c2-6 8-9 10-9s8 3 10 9" stroke={accent} strokeWidth="2.5" strokeLinecap="round" opacity=".4" fill="none" />
    </svg>
  );
  return null;
}

export default function MiniToolsRow({ onToolClick }) {
  return (
    <div style={{ marginBottom: 44 }}>
      <style>{`
        .l2i-mini-card { transition: transform .2s cubic-bezier(.2,.7,.3,1), box-shadow .2s; }
        .l2i-mini-card:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(15,23,42,.08); }
        .l2i-mini-grid {
          display: grid;
          grid-template-columns: repeat(${TOOLS.length}, 1fr);
          gap: 10px;
        }
        @media (max-width: 860px) {
          .l2i-mini-grid { grid-template-columns: repeat(2, 1fr); }
        }
      `}</style>

      <div className="l2i-mini-grid">
        {TOOLS.map((tool, i) => (
          <button key={i}
            onClick={() => onToolClick?.(tool)}
            className="l2i-mini-card"
            style={{
              position: 'relative', overflow: 'hidden',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
              minHeight: 96, padding: '12px 14px',
              background: tool.grad, border: '1px solid rgba(15,23,42,.05)', borderRadius: 14,
              cursor: 'pointer', textAlign: 'left', minWidth: 0,
            }}>
            <MiniArt tag={tool.art} accent={tool.accent} />
            <span style={{ position: 'relative', zIndex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontSize: 13.5, fontWeight: 800, color: C.n900, letterSpacing: '-.01em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {tool.label}
              </span>
              <span style={{ display: 'block', fontSize: 11.5, color: C.n600, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {tool.sub}
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
